module.exports = __webpack_public_path__ + "img/Michael_Alexander_Riegler@2x.7a54ba5f.png";